import React, { useEffect, useState } from "react";
import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

export const SSUMenu = () => {
  const [current, setCurrent] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const history = useHistory();
  const role = useSelector((state) => state.authentication.userData?.roles[0].roleName);
  const isOrganizer = useSelector((state) => state.authentication.authority.ORGANIZATOR_EDUKACIJE === "true" ? true : false);

  useEffect(() => {
    if (role === "ROLE_REFERENT" || role === "ROLE_SLUZBENIK") {
      setIsVisible(true);
    }
    switch (history.location.pathname) {
      case "/organizatori":
        setCurrent("organizatori");
        break;
      case "/strucna-usavrsavanja":
        setCurrent("ovlRev");
        break;
      case "/edukacije":
        setCurrent("edukacije");
        break;
      case "/godPlan":
        setCurrent("godPlan");
      default:
        break;
    }
  }, [history]);

  return (
    <Menu mode="horizontal" activeKey={current}>
      <Menu.Item key="ovlRev">
        <Link to="/strucna-usavrsavanja" style={{ textDecoration: "none" }}>
          <h5>Ovlašteni revizori</h5>
        </Link>
      </Menu.Item>

      {isVisible && (
        <Menu.Item key="organizatori">
          <Link to="/organizatori" style={{ textDecoration: "none" }}>
            <h5>Organizatori</h5>
          </Link>
        </Menu.Item>
      )}

      <Menu.Item key="edukacije">
        <Link to="/edukacije" style={{ textDecoration: "none" }}>
          <h5>Edukacije</h5>
        </Link>
      </Menu.Item>
      
      {isOrganizer &&
        <Menu.Item key="godPlan">
          <Link to="/godPlan" style={{textDecoration : "none"}}>
            <h5>Godišnji plan</h5>
          </Link>
        </Menu.Item>
      }

    </Menu>
  );
};
